module.exports = __webpack_public_path__ + "img/undraw_businesswoman_pc12.70c33397.svg";